import { formatNumberWithSpaces } from 'utils/format-number-with-spaces'

import cn from 'classnames'

import styles from '../styles.module.scss'

import { IBalanceView } from '..'

const OtherBalance = ({ balance, className }: { balance: IBalanceView; className?: string }) => {
  return (
    <div className={cn(styles.detail, className)}>
      <div className={styles.detail__content}>
        <div className={cn(styles.detail__content__line, balance.classNameColor)}></div>
        <div className={styles.detail__content__coin}>
          {balance.code.toUpperCase()}
          {balance.network ? ` (${balance.network.toUpperCase()})` : ''} - {balance.percent}%
        </div>
      </div>
      <div className={styles.detail__amount}>${formatNumberWithSpaces(balance.amount)}</div>
    </div>
  )
}

export default OtherBalance
